// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-autocomplete {
  display: none;
  position: absolute;
  width: var(--ac-width);
  min-width: 280px;
  top: var(--ac-dropdown-top);
  right: 0;
  padding: 4px;
  border: 1px solid #1fa9b0;
  background-color: #fff;
  z-index: 4;
}
.dropdown-autocomplete.dis-bl {
  display: block;
}
.dropdown-autocomplete ul > li {
  padding: 4px 8px;
  user-select: none;
  cursor: pointer;
}
.dropdown-autocomplete ul > li.marked {
  color: #fff;
  background-color: #1fa9b0;
}
.working-indicator {
  display: block;
  position: absolute;
  height: 3px;
  width: var(--ac-width);
  border-radius: 1px;
  overflow: hidden;
  pointer-events: none;
}
.working-indicator.btm {
  bottom: 0;
}
.working-indicator.top {
  top: 0;
}
.working-indicator:before {
  content: '';
  display: block;
  position: absolute;
  height: 100%;
  width: 0px;
}
.working-indicator:before {
  background-color: #198a8f3b;
}
@keyframes loading {
  0% {
    width: 0px;
    transform: translateX(-24px);
  }
  1% {
    width: 12px;
    transform: translateX(-24px);
  }
  25% {
    width: 60px;
    transform: translateX(calc(var(--ac-width) * 0.1));
  }
  60% {
    width: 100px;
    transform: translateX(calc(var(--ac-width) * 0.6));
  }
  99% {
    width: 120px;
    transform: translateX(calc(var(--ac-width) + 40px));
  }
  100% {
    width: 0px;
    transform: translateX(calc(var(--ac-width) + 120px));
  }
}
`, "",{"version":3,"sources":["webpack://./PluginsCustom/style.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AACJ;AACI;EACI,cAAA;AACR;AAdA;EAiBQ,gBAAA;EACA,iBAAA;EACA,eAAA;AAAR;AAEQ;EACI,WAAA;EACA,yBAAA;AAAZ;AAKA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAHJ;AAKI;EACI,SAAA;AAHR;AAMI;EACI,MAAA;AAJR;AAOI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AALR;AAQI;EACI,2BAAA;AANR;AAUA;EACI;IACI,UAAA;IACA,4BAAA;EARN;EAWE;IACI,WAAA;IACA,4BAAA;EATN;EAYE;IACI,WAAA;IACA,kDAAA;EAVN;EAaE;IACI,YAAA;IACA,kDAAA;EAXN;EAcE;IACI,YAAA;IACA,mDAAA;EAZN;EAeE;IACI,UAAA;IACA,oDAAA;EAbN;AACF","sourcesContent":[".dropdown-autocomplete {\n  display: none;\n  position: absolute;\n  width: var(--ac-width);\n  min-width: 280px;\n  top: var(--ac-dropdown-top);\n  right: 0;\n  padding: 4px;\n  border: 1px solid #1fa9b0;\n  background-color: #fff;\n  z-index: 4;\n}\n.dropdown-autocomplete.dis-bl {\n  display: block;\n}\n.dropdown-autocomplete ul > li {\n  padding: 4px 8px;\n  user-select: none;\n  cursor: pointer;\n}\n.dropdown-autocomplete ul > li.marked {\n  color: #fff;\n  background-color: #1fa9b0;\n}\n.working-indicator {\n  display: block;\n  position: absolute;\n  height: 3px;\n  width: var(--ac-width);\n  border-radius: 1px;\n  overflow: hidden;\n  pointer-events: none;\n}\n.working-indicator.btm {\n  bottom: 0;\n}\n.working-indicator.top {\n  top: 0;\n}\n.working-indicator:before {\n  content: '';\n  display: block;\n  position: absolute;\n  height: 100%;\n  width: 0px;\n}\n.working-indicator:before {\n  background-color: #198a8f3b;\n}\n@keyframes loading {\n  0% {\n    width: 0px;\n    transform: translateX(-24px);\n  }\n  1% {\n    width: 12px;\n    transform: translateX(-24px);\n  }\n  25% {\n    width: 60px;\n    transform: translateX(calc(var(--ac-width) * 0.1));\n  }\n  60% {\n    width: 100px;\n    transform: translateX(calc(var(--ac-width) * 0.6));\n  }\n  99% {\n    width: 120px;\n    transform: translateX(calc(var(--ac-width) + 40px));\n  }\n  100% {\n    width: 0px;\n    transform: translateX(calc(var(--ac-width) + 120px));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
